export function getMousePosition(e, node) {
    const { top, height, left } = node.getBoundingClientRect();
    const y = e.clientY - top;
    const x = e.clientX - left;
    const bottom = top + height - e.clientY;
    return { top: y, bottom, left: x };
}
//# sourceMappingURL=helpers.js.map